import { createAPI } from '@common'
export default {
  // 获取置顶公告过期时间
  getSystemNoticeSortingExpireTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0tpsujoh0fyqjsfUjnf', 'get', config),
  // 公告置顶
  postSystemNoticeSortingTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0tpsujoh0upq', 'post', config)
}
